const getLanguageCode = (): string => {
  const {
    navigator: { language },
  } = window;
  const languageCode = language.length > 2 ? language.substring(0, 2) : language;
  return languageCode;
};

export default getLanguageCode;
